import type { ConversationFileEntry } from '../../../stores/chatStore';

export type FileStagingState = 'staged-for-upload' | 'staged-for-delete' | 'uploaded' | 'none';
export type UploadStatusOverride = 'pending' | 'uploading' | 'completed' | 'error';

interface Options {
  stagedForDelete?: boolean;
  defaultUploaded?: boolean;
}

/**
 * Maps a ConversationFileEntry into UI-facing status values used by components.
 * Ensures consistent processing vs uploaded visuals between modal and inline flows.
 */
export function getFileUIState(
  entry: ConversationFileEntry | undefined,
  { stagedForDelete = false, defaultUploaded = true }: Options = {}
): { uploadStatusOverride: UploadStatusOverride; stagingState: FileStagingState } {
  const isProcessing = !!entry && (entry.status === 'queued' || entry.status === 'uploading');
  const isDeleting = entry?.status === 'deleting';

  const uploadStatusOverride: UploadStatusOverride = entry?.status === 'error'
    ? 'error'
    : isProcessing
      ? 'uploading'
      : 'completed';

  let stagingState: FileStagingState;
  if (stagedForDelete || isDeleting) stagingState = 'staged-for-delete';
  else if (isProcessing) stagingState = 'staged-for-upload';
  else stagingState = defaultUploaded ? 'uploaded' : 'none';

  return { uploadStatusOverride, stagingState };
}
